import {
  useCallback,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  DateTime,
} from 'luxon';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';
import {
  getUiState,
} from 'web-selectors';

import {
  Modal,
  Button,
  Avatar,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

interface Props {
  id?: number
  onRequestClose: { (): void }
}

const ActivityModal = ({
  id,
  onRequestClose,
}: Props) => {
  const resourceType = 'activityLogs';
  const mapState = useCallback(state => ({
    event: id ? coreSelectors.getCurrentEvent(resourceType, id)(state) : {},
    activityLoggerModal: getUiState('activityLoggerModal')(state),
  }), [id]);

  const {
    event,
    activityLoggerModal,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  const handleDelete = useCallback(() => {
    const onConfirmAction = coreActions.requestDeleteEntity({
      id: id!,
      resourceType,
    });

    onRequestClose();
    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Remove Activity?',
          bodyText: 'Are you sure you want remove activity?',
        },
        onConfirmAction,
      }),
    );
  }, [id]);

  const handleEdit = useCallback(() => {
    dispatch(
      uiActions.setUiState({
        activityLoggerModal: {
          isOpen: true,
          initialValues: {
            id: event.id,
            person_id: event.person_id,
            begins_at: DateTime.fromISO(event.begins_at),
            ends_at: DateTime.fromISO(event.ends_at),
            workout_name: event.workout_name,
            description: event.description,
          },
        },
      }),
    );
  }, [id]);

  return (
    <Modal
      title="Activity"
      isOpen={!!id}
      overlayStyle={
        activityLoggerModal.isOpen ? {
          backgroundColor: 'transparent',
        } : {}
      }
      contentStyle={{ width: 400 }}
      onRequestClose={onRequestClose}
    >
      <Flex
        column
        width="100%"
        align="flex-start"
        spacing={25}
      >
        <S.Header spacing={14}>
          <Avatar
            src={event.avatar?.thumb?.url}
            width="80px"
            height="80px"
            borderColor="primary"
            borderWidth={3}
            placeholderSize={40}
          />
          <Flex column>
            <Text
              size="20px"
              color="#333333"
              weight={700}
              lineHeight="23px"
            >
              {event.person_name}
            </Text>
            <Text color="#5f5f5f" size="16px">
              {event.workout_name}
            </Text>
            <Text color="#5f5f5f" size="16px">
              {event.start}
            </Text>
          </Flex>
        </S.Header>
        <Flex column spacing={15}>
          <Text
            whiteSpace="pre-wrap"
            wordBreak="break-word"
          >
            {event.description}
          </Text>
        </Flex>

        <Flex width="100%" justify="space-between">
          <Button
            ghost
            spacing="large"
            appearance="danger"
            onClick={handleDelete}
          >
            Delete
          </Button>
          <Button
            ghost
            spacing="large"
            appearance="primary"
            onClick={handleEdit}
          >
            Edit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ActivityModal;
